import React, { Fragment } from 'react';
import ListGroup from 'react-bootstrap/ListGroup'
import '../../assets/css/scss/component/_leagueListVertical.scss'

interface ILeagueListVerticalData {
    list?: string[]
}
export default function LeagueListVertical(props: ILeagueListVerticalData) {
    return (
        <Fragment>
            <ListGroup as="ul" bsPrefix="list-group league-list list-unstyled text-md-center">
                <ListGroup.Item className="font-16 bold" as="li">
                    <i className="icon-Asset-4"></i> <span>Leagues</span>
                </ListGroup.Item>
                {props?.list?.map((data) => (
                    <ListGroup.Item className="font-16 bold active text-uppercase" as="li">
                        <span>{data}</span>
                    </ListGroup.Item>
                ))}
                {/* <ListGroup.Item className="font-16 bold" as="li">
                    <span>NPB</span>
                </ListGroup.Item> */}
            </ListGroup>
        </Fragment>
    )
}
